import { React, useState, useEffect, useRef } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CornerDownRight, CheckSquare, SquareCheck } from 'lucide-react';
import dayjs from 'dayjs';
import { CheckIcon, CloseIcon, InfoIcon, WarningIcon } from '@chakra-ui/icons';
import Tasksubtasktable from '../Board/Tasksubtasktable';
import { CornerDownLeft } from 'lucide-react';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import SkeletonWithLoaders from 'components/common/Spinner';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Select,
} from '@chakra-ui/react';
import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';
import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import TaskmodalActivity from '../Board/TaskmodalActivity';
import {
  ThunderboltOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import Epicmodalactivity from '../Timeline/Epicmodalactivity';

import AttachmentList from '../Timeline/attachment/AttachmentList';
import AttachmentMenuItem from '../attachments/AttachmentMenuItem';
import { AttachmentProvider } from '../attachments/AttachmentProvider';

import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

import ShareWorkItemModal from '../share/ShareWorkItemModal';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';

const { Option } = Select;

const ListEpicModal = ({
  isOpen,
  onClose,
  epicDetails,
  projectId,
  fetchData,
  opentaskmodal,
  taskDetails,
  //issueTypes
}) => {
 
  const [loading, setLoading] = useState(true);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  // const [editedTitle, setEditedTitle] = useState(taskdata?.task_title || '');
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTasks, setChildTasks] = useState([]);
  //const [issueTypes, setIssueTypes] = useState([]);

  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');

  const [attachments, setAttachments] = useState([]); // attachment state here

  const [isShareOpen, setIsShareOpen] = useState(false); // share modal state

  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [epicdata, setEpicData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [selectedIssueTypeId, setSelectedIssueTypeId] = useState(1);
  const [selectedType, setSelectedType] = useState('TASK');
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');

  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [reloadSubtasks, setReloadSubtasks] = useState(0);

  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);

  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');
  const [epicList, setEpicList] = useState([]);

  const [visibleReplies, setVisibleReplies] = useState({});
  const [editingText, setEditingText] = useState('');

  const [isEditingComment, setIsEditingComment] = useState(false);
  const [activeReplyEditor, setActiveReplyEditor] = useState(null);
  const EpicList = useSelector((state) => state?.Authentication?.Epiclist);
  const [editedepicTitle, setEditedepicTitle] = useState(
    epicdata?.epic_name || '',
  );
  const [isEditingepicTitle, setIsEditingepicTitle] = useState(false);
  const [epicColor, setEpicColor] = useState('#8b5cf6');

  const dispatch = useDispatch();

  const [storyPoints, setStoryPoints] = useState('');
  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );
  const statusList = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const [innerBoxWidth, setInnerBoxWidth] = useState(400);
  const innerResizingRef = useRef(false);
  const startInnerXRef = useRef(0);
  const startInnerWidthRef = useRef(0);
  const MIN_WIDTH = 250;
  const getMaxWidth = () =>
    Math.min(window.innerWidth * 0.5, window.innerWidth - 250);
  // 50% of screen or leave 250px for left panel

  const [rightWidth, setRightWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  const resizingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const onMouseDown = (e) => {
    resizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = rightWidth;
    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!resizingRef.current) return;
    const dx = e.clientX - startXRef.current;

    let newW = startWidthRef.current - dx; // drag right -> shrink
    const MAX_WIDTH = getMaxWidth();
    newW = Math.min(Math.max(newW, MIN_WIDTH), MAX_WIDTH);
    setRightWidth(newW);
  };

  const onMouseUp = () => {
    resizingRef.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  const roleId = Number(Cookies.get('task-role-id'));

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };
  const currentStatus = newstatus || epicdata?.epic_status;
  const { bg, color } = getStatusColors(currentStatus);

  const isEditable = [1, 2, 3].includes(roleId);

  const handleCancel = () => {
    setEditedepicTitle(epicdata?.issue_title || '');
    setIsEditingepicTitle(false);
  };

  const handleSaveLink = (data) => {
   
    setRefreshLinks((prev) => !prev);
    setShowWebLink(false);
  };

   const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(epicdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(epicdata.start_date),
  );

  useEffect(() => {
    if (epicdata?.labels) {
      const formatted = epicdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [epicdata]);

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
     
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        epic_id: epicDetails.epic_id,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      // ❗Attach only CURRENT selected IDs, NOT old
      requestBody.labels_id = existingLabelIds; // even if empty []

      const response =
        await httpInjectorService.createandADDepicLabels(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response?.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseWithSave = () => {
    onClose();
  };

  const getEpicDetails = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const response = await httpInjectorService.getEpicdetails(reqbody);

      if (response.status === 'success') {
        setEpicData(response?.data);
      } else {
        setEpicData({});
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // when epicDetails has a value (and not just an empty object), stop loading
    setLoading(true);

    getEpicDetails();
    if (isOpen && epicdata) {
      setLoading(false);
    }
  }, [epicDetails]);

  const handleEpicUpdate = async (emp = {}) => {
    const finalEpicColor = emp?.epic_color || epicdata?.epic_colour;
    const finalBody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
      epic_name: editedepicTitle || epicDetails?.name,
      sprint_id: selectedSprint?.value || epicdata?.sprint_id || null,
      epic_story_points: storyPoints || epicdata?.epic_story_points || null,
      assignee_id: emp?.user_id || epicdata?.assignee_id || null,
      description: description?.trim() || epicdata?.description || '',
      epic_status: emp?.status_name || epicdata?.epic_status,
      issue_priority: epicdata.issue_priority,
      start_date: startDate || epicdata?.start_date,
      due_date: dueDate || epicdata?.due_date,
      epic_colour: finalEpicColor,
    };

    try {
      const response = await httpInjectorService.UpdateEpicDetails(finalBody);

      if (response?.status === 'success') {
        getEpicDetails();
      }
    } catch (error) {
      console.error('Error updating task:', error);
      toast.error('Something went wrong.');
    }
  };

  const gettaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const response = await httpInjectorService.gettaskwithEpicId(reqbody);
      setChildTasks(response.data);

      // assuming array of { id, title }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    } finally {
      setLoadingSubtasks(false);
    }
  };



  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = epicdata?.sprint_name || ' ';
        const matchedSprint = options.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      setSprintlist([]);
    }
  };

  const getEpiccomments = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicDetails.epic_id,
    };
    try {
      const res = await httpInjectorService.getEpicComments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      console.error('Error fetching comments:', err);
    }
  };

  const issueTypes = [
    { id: 1, label: 'Task', icon: TaskObject },
    { id: 2, label: 'Story', icon: StoryObject },
    { id: 3, label: 'Bug', icon: BugObject },
  ];

  useEffect(() => {
    if (isOpen && epicDetails?.epic_id) {
      getsprintlist();
      getLabelList();
      getEpiccomments();
      getEpicDetails();
      gettaskList();
    }
  }, [isOpen, epicDetails]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicdata.epic_id,
      sprint_id: epicdata.sprint_id,
      issue_title: childTaskTitle || '',
      issue_type_id: selectedIssueTypeId,
      issue_type: selectedType,
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addtaskwithEpic(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        gettaskList(); // Refresh list
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      console.error('Error adding subtask:', error);
    }
  };

  const saveSubtask = async (taskId, updatedFields = {}) => {
    const edited = editableTasks[taskId] || {};

    const original = childTasks.find((t) => t.issue_id === taskId);

    if (!original) {
      console.error('Original task not found');
      return;
    }

    const reqBody = {
      project_id: projectId, // or dynamic
      issue_id: taskId,
      issue_type_id: original?.issue_type_id,
      epic_id: epicDetails.epic_id,
      sprint_id: original?.sprint_id,
      issue_title:
        edited.title !== undefined ? edited.title : original?.issue_title,
      issue_status: updatedFields.status
        ? updatedFields.status
        : original.issue_status,
      issue_priority: updatedFields.priority
        ? updatedFields.priority
        : original.issue_priority,
      assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
    };

    try {
      const response = await httpInjectorService.Taskedit(reqBody);
      if (response.status === 'success') {
        gettaskList();
        // Optionally refresh or give feedback
      }
    } catch (error) {
      console.error('Error saving subtask:', error);
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };
  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const status = epicdata?.issue_status_count || {};

  const done = parseInt(status?.DONE || 0, 10);

  const total = parseInt(status?.issue_count || 0, 10);

  // Calculate % safely
  const donePercent = total > 0 ? (done / total) * 100 : 0;

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const debouncedUpdate = useCallback(
    debounce(() => handleEpicUpdate(), 400),
    [handleEpicUpdate],
  );

  const fetchAttachments = async () => {
    if (!projectId || !epicDetails?.epic_id) {
      setAttachments([]);
      return;
    }

    try {
      const payload = {
        project_id: projectId,
        epic_id: epicDetails.epic_id || null,
        epic_key: epicdata?.epic_key || null,
      };

     

      const res = await httpInjectorService.getAttachment(payload);

      if (res?.status === 'success' && Array.isArray(res.data)) {
        setAttachments(res.data);
      } else {
        setAttachments([]);
      }
    } catch (error) {
      console.error('Error fetching attachments:', error);
      setAttachments([]);
    }
  };
  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev); // toggle
  };
  // delete attachment
  const handleDeleteAttachment = async (id) => {
    setAttachments((prev) => prev.filter((att) => att.attachment_id !== id));

    // Optional backend api call
    await httpInjectorService.deleteAttachment({
      attachment_id: id,
      project_id: projectId,
    });

    toast.success('Attachment removed', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  useEffect(() => {
    if (isOpen && projectId && epicDetails?.epic_id) {
      fetchAttachments();
    }
  }, [isOpen, projectId, epicDetails?.epic_id]);

  const getIssueIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'TASK':
        return <TaskObject size="medium" />;
      case 'BUG':
        return <BugObject size="medium" />;
      case 'STORY':
        return <StoryObject size="medium" />;
      default:
        return <TaskObject size="medium" />; // fallback
    }
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={handleCloseWithSave}
        size="7xl"
        isCentered
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent maxW="95vw" w="90vw" maxH="90vh">
          <ModalHeader>
            <Flex justify="space-between" align="center">
              <HStack spacing={0} align="center">
                <HStack spacing={1} align="center">
                  <Flex align="center" gap={1}>
                    <Text fontSize="md" color="gray.600">
                      <span>
                        <ThunderboltOutlined style={{ color: '#884B9E' }} />{' '}
                        {epicdata?.epic_key}
                      </span>
                    </Text>
                  </Flex>
                </HStack>
              </HStack>
              <HStack spacing={2}>
                <IconButton
                  icon={<FaLock />}
                  size="lg"
                  variant="ghost"
                  aria-label="lock"
                />
                <IconButton
                  icon={<FaEye />}
                  size="lg"
                  variant="ghost"
                  aria-label="view"
                />
                <IconButton
                  icon={<FaShareAlt />}
                  size="lg"
                  variant="ghost"
                  aria-label="share"
                  onClick={() => setIsShareOpen(true)}
                />
                <Flex align="center" gap={4}>
                  {/* Open in new tab icon */}
                  <a
                    href={`/admin/timeline/${projectId}/EpicDetails/${epicDetails?.epic_id}`}
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
                  </a>
                </Flex>
                <IconButton
                  icon={<AiOutlineThunderbolt />}
                  size="sm"
                  variant="ghost"
                  aria-label="action"
                />
                <ModalCloseButton position="static" />
              </HStack>
            </Flex>
          </ModalHeader>

          <ModalBody
            p={0}
            style={{
              overflowY: 'hidden', // vertical scrolling
              // prevent horizontal scroll
              // smooth height change
            }}
          >
            {loading ? (
              <Flex justify="center" align="center" w="100%" h="300px">
                <SkeletonWithLoaders />
              </Flex>
            ) : (
              <Flex>
                <Box
                  flex="1"
                  p={6}
                  overflowY="auto"
                  bg="white"
                  style={{
                    height: 'calc(100vh - 210px)', // adjust top/bottom offset as needed
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', // vertical scrolling
                    // prevent horizontal scroll
                    transition: 'height 0.2s ease', // smooth height change
                  }}
                >
                  <Box mb={4}>
                    {!isEditingepicTitle ? (
                      <Text
                        fontSize="2xl"
                        fontWeight="bold"
                        cursor="pointer"
                        onClick={() => {
                          if ([1, 2, 3].includes(roleId)) {
                            setEditedepicTitle(epicdata?.epic_name);
                            setIsEditingepicTitle(true);
                          }
                        }}
                      >
                        {editedepicTitle || epicdata?.epic_name || 'Epic Title'}
                      </Text>
                    ) : (
                      <Box position="relative" width="100%">
                        <Input
                          value={editedepicTitle}
                          onChange={(e) => setEditedepicTitle(e.target.value)}
                          size="lg"
                          fontSize="2xl"
                          fontWeight="bold"
                          autoFocus
                          height="40px"
                          focusBorderColor="gray.300"
                          borderRadius="md"
                        />

                        <HStack
                          spacing={2}
                          position="absolute"
                          right="0"
                          top="100%"
                          mt={1}
                          pointerEvents="none"
                        >
                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={() => {
                              handleEpicUpdate(); // call the update function
                              setIsEditingepicTitle(false); // exit edit mode
                            }}
                          >
                            <CheckIcon boxSize={4} color="grey" />
                          </Box>

                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={handleCancel}
                          >
                            <CloseIcon boxSize={4} color="grey" />
                          </Box>
                        </HStack>
                      </Box>
                    )}

                    {[1, 2, 3].includes(roleId) && (
                      <AttachmentProvider
                        context={{
                          project_id: projectId,
                          epic_id: epicDetails.epic_id || null,
                          epic_key: epicdata?.epic_key || null,
                        }}
                        onUploaded={fetchAttachments}
                      >
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            icon={<AddIcon />}
                            size="sm"
                            aria-label="Add actions"
                            bg="#f3f4f6"
                            border="1px solid #d1d5db"
                            borderRadius="md"
                            _hover={{ bg: '#e5e7eb' }}
                            _active={{ bg: '#e5e7eb' }}
                            color="gray.700"
                            mt={1}
                            mb={30}
                            position="relative"
                            zIndex={1}
                          />

                          <MenuList zIndex={1}>
                            <MenuItem onClick={() => setShowChildInput(true)}>
                              Create child work item
                            </MenuItem>
                            <MenuItem
                             onClick={handleOpenLinkWorkItem}
                            >
                              Link work Items
                            </MenuItem>

                            {/* attachment menu item button UI */}
                            <AttachmentMenuItem />

                            <MenuItem
                              onClick={() => {
                                console.log('clicked');
                                setShowWebLink(true);
                              }}
                            >
                              Add web link
                            </MenuItem>
                            <MenuItem
                              onClick={() => console.log('Assign task clicked')}
                            >
                              Page
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                console.log('Add attachment clicked')
                              }
                            >
                              Whiteboard
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </AttachmentProvider>
                    )}
                  </Box>

                  <Box mb={6} mt={2}>
                    <Text fontWeight="semibold" mb={2}>
                      Description
                    </Text>

                    {!isEditingDescription ? (
                      <Box
                        p={3}
                        border="1px solid #e2e8f0"
                        borderRadius="8px"
                        minH="80px"
                        bg="white"
                        onClick={() =>
                          [1, 2, 3].includes(roleId) &&
                          setIsEditingDescription(true)
                        }
                        cursor={
                          ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                        }
                      >
                        {description ? (
                          <Box
                            dangerouslySetInnerHTML={{ __html: description }}
                            fontSize="sm"
                          />
                        ) : (
                          <Text color="gray.400" fontSize="sm">
                            Add a description...
                          </Text>
                        )}
                      </Box>
                    ) : (
                      <Box>
                        <ReactQuill
                          theme="snow"
                          value={description}
                          onChange={setDescription}
                          placeholder="Write a description..."
                          modules={{
                            toolbar: [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              ['link', 'image', 'code-block'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            minHeight: '120px',
                          }}
                        />
                        <Flex justify="flex-end" mt={2}>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            borderRadius="0px"
                            onClick={() => {
                              setIsEditingDescription(false);
                              handleEpicUpdate('description', description); // ✅ Save on Done click
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            borderRadius="0px"
                            onClick={() => setIsEditingDescription(false)}
                          >
                            cancel
                          </Button>
                        </Flex>
                      </Box>
                    )}
                  </Box>

                     {openLinkWorkItem && (
                    <div style={{ marginTop: '16px' }}>
                      <LinkWorkItemInput
                        onCancel={() => setOpenLinkWorkItem(false)}
                        current_item_type={'epic'}
                        current_item_id={epicdata.epic_id}
                        onSuccess={triggerRefresh}
                      />
                    </div>
                  )}

                  {showWebLink && (
                    <WebLink
                      onClose={() => setShowWebLink(false)}
                      onSave={handleSaveLink}
                      work_id={epicDetails.epic_id}
                      work_type={'epic'}
                    />
                  )}
                 

                  {/* Add attachment UI */}
                  <Box mb={6}>
                    {attachments?.length > 0 && (
                      <AttachmentList
                        onDelete={handleDeleteAttachment}
                        attachments={attachments}
                      />
                    )}
                  </Box>

                  <Tabs variant="unstyled">
                    {/* Tabs */}
                    <TabList gap={2}>
                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Subtasks
                      </Tab>

                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Linked Items
                      </Tab>
                    </TabList>

                    {/* Tab Content */}
                    <TabPanels mt={4}>
                      {/* Subtasks */}
                      <TabPanel p={0}>
                        {childTasks?.length > 0 &&
                          [1, 2, 3].includes(roleId) && (
                            <Box mt={6}>
                              <Text fontWeight="semibold" mb={2}>
                                SubTasks
                              </Text>
                              {/* Progress Bar Section */}
                              {epicdata?.issue_status_count && (
                                <Flex alignItems="center" gap={4}>
                                  <Box
                                    flex="1"
                                    display="flex"
                                    alignItems="center"
                                  >
                                    {/* Progress Bar */}
                                    <Flex
                                      w="100%"
                                      h="10px"
                                      borderRadius="8px"
                                      overflow="hidden"
                                      bg="#E2E8F0"
                                    >
                                      {(() => {
                                        const counts =
                                          epicdata.issue_status_count;
                                        const total =
                                          Number(
                                            epicdata?.issue_status_count
                                              ?.issue_count,
                                          ) || 1;

                                        // Fixed
                                        const todo = Number(
                                          counts['TO DO'] || 0,
                                        );
                                        const done = Number(
                                          counts['DONE'] || 0,
                                        );

                                        // Dynamic statuses (merged into BLUE)
                                        let blue = 0;
                                        let blueStatusText = [];

                                        Object.keys(counts).forEach((key) => {
                                          if (
                                            key !== 'TO DO' &&
                                            key !== 'DONE' &&
                                            key !== 'issue_count'
                                          ) {
                                            const c = Number(counts[key] || 0);
                                            blue += c;
                                            blueStatusText.push(`${key}: ${c}`);
                                          }
                                        });

                                        const todoPercent =
                                          (todo / total) * 100;
                                        const bluePercent =
                                          (blue / total) * 100;
                                        const donePercent =
                                          (done / total) * 100;

                                        return (
                                          <>
                                            {/* DONE (green) */}
                                            <Tooltip
                                              label={`DONE: ${done} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${donePercent}%`}
                                                bg="#38A169"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>

                                            {/* BLUE (other statuses) */}
                                            <Tooltip
                                              label={`IN PROGRESS: ${blue} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${bluePercent}%`}
                                                bg="#3182CE"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                            {/* TO DO (grey) */}
                                            <Tooltip
                                              label={`TO DO: ${todo} of ${total}`}
                                              hasArrow
                                              placement="top"
                                            >
                                              <Box
                                                w={`${todoPercent}%`}
                                                bg="#A0AEC0"
                                                mx="1px"
                                                borderRadius="4px"
                                              />
                                            </Tooltip>
                                          </>
                                        );
                                      })()}
                                    </Flex>
                                  </Box>

                                  {/* Work Done Percentage */}
                                  <Text
                                    fontWeight="600"
                                    whiteSpace="nowrap"
                                    lineHeight="10px" // match progress bar height
                                    display="flex"
                                    alignItems="center" // perfect vertical alignment
                                  >
                                    Done: {Math.round(donePercent)}%
                                  </Text>
                                </Flex>
                              )}

                              <Box
                                borderWidth="1px"
                                borderRadius="md"
                                overflow="hidden"
                                boxShadow="sm"
                              >
                                <Box maxH="300px" overflowY="auto">
                                  <Table size="sm" border="1px solid #E2E8F0">
                                    <Thead
                                      bg="gray.100"
                                      position="sticky"
                                      top={0}
                                      zIndex={1}
                                    >
                                      <Tr>
                                        <Th borderRight="1px solid #E2E8F0"></Th>
                                        <Th
                                          borderRight="1px solid #E2E8F0"
                                          w="300px"
                                        >
                                          Work
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Priority
                                        </Th>
                                        <Th borderRight="1px solid #E2E8F0">
                                          Assignee
                                        </Th>
                                        <Th>Status</Th>
                                        {/* <Th>Actions</Th> */}
                                      </Tr>
                                    </Thead>

                                    <Tbody>
                                      {childTasks.map((task) => {
                                        const edited =
                                          editableTasks[task.issue_id] || {};

                                        const assigneeIdToUse =
                                          edited.assignee_id !== undefined
                                            ? edited.assignee_id
                                            : task.assignee_id;

                                        const assigneeObj = assigneeList.find(
                                          (a) => a.user_id === assigneeIdToUse,
                                        );

                                        const subtaskTitle =
                                          edited.title !== undefined
                                            ? edited.title
                                            : task.issue_title;
                                        const selectedStatus =
                                          edited.status ||
                                          task.issue_status ||
                                          'TO DO';
                                        const handleSave = () =>
                                          saveSubtask(task.issue_id);

                                        return (
                                          <Tr key={task.issue_id}>
                                            <Td w="120px">
                                              <Box
                                                as="button"
                                                //onClick={() => opentaskmodal(task)}
                                                display="flex"
                                                alignItems="center"
                                                gap="6px"
                                                bg="transparent"
                                                border="none"
                                                cursor="pointer"
                                                color="#3182ce"
                                                fontWeight="500"
                                                padding={0}
                                                _hover={{
                                                  textDecoration: 'underline',
                                                  color: '#0056b3',
                                                }} // blue hover link
                                              >
                                                {getIssueIcon(task.issue_name)}
                                                {task.issue_key}
                                              </Box>
                                            </Td>

                                            {/* Editable title */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="400px"
                                            >
                                              <Tooltip
                                                label={subtaskTitle}
                                                hasArrow
                                                placement="top"
                                                openDelay={300}
                                              >
                                                <Input
                                                  size="sm"
                                                  value={subtaskTitle}
                                                  onChange={(e) =>
                                                    handleEditChange(
                                                      task.issue_id,
                                                      'title',
                                                      e.target.value,
                                                    )
                                                  }
                                                  onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                      e.target.blur(); // lose focus first
                                                      handleSave();
                                                    }
                                                  }}
                                                  onBlur={() => {
                                                    // Only save if value actually changed
                                                    if (
                                                      subtaskTitle !==
                                                      task.issue_title
                                                    ) {
                                                      handleSave();
                                                    }
                                                  }}
                                                />
                                              </Tooltip>
                                            </Td>

                                            {/* Priority */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="100px"
                                            >
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {edited.priority ||
                                                    task.issue_priority ||
                                                    'Medium'}
                                                </MenuButton>
                                                <MenuList>
                                                  {[
                                                    'Low',
                                                    'Medium',
                                                    'High',
                                                  ].map((priority) => (
                                                    <MenuItem
                                                      key={priority}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.issue_id,
                                                          'priority',
                                                          priority,
                                                        );
                                                        saveSubtask(
                                                          task.issue_id,
                                                          {
                                                            priority,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {priority}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Assignee */}
                                            <Td
                                              borderRight="1px solid #E2E8F0"
                                              w="120px"
                                            >
                                              <Menu isLazy>
                                                <Tooltip
                                                  label={
                                                    assigneeObj
                                                      ? assigneeObj.username
                                                      : 'Unassigned'
                                                  }
                                                  hasArrow
                                                  placement="top"
                                                  openDelay={300}
                                                >
                                                  <MenuButton
                                                    as={Button}
                                                    variant="ghost"
                                                    size="sm"
                                                    rightIcon={
                                                      <ChevronDownIcon />
                                                    }
                                                  >
                                                    <Box>
                                                      <UserAvatar
                                                        username={
                                                          assigneeObj
                                                            ? assigneeObj.username
                                                            : 'Unassigned'
                                                        }
                                                        size={24}
                                                      />
                                                    </Box>
                                                  </MenuButton>
                                                </Tooltip>

                                                <MenuList
                                                  maxH="200px"
                                                  overflowY="auto"
                                                  zIndex={1500}
                                                >
                                                  {assigneeList.map(
                                                    (assignee) => (
                                                      <MenuItem
                                                        key={assignee.user_id}
                                                        onClick={() => {
                                                          handleEditChange(
                                                            task.issue_id,
                                                            'assignee_id',
                                                            assignee.user_id,
                                                          );
                                                          saveSubtask(
                                                            task.issue_id,
                                                            {
                                                              assignee_id:
                                                                assignee.user_id,
                                                            },
                                                          );
                                                        }}
                                                      >
                                                        <Tooltip
                                                          label={
                                                            assignee.username
                                                          }
                                                          hasArrow
                                                          placement="right"
                                                          openDelay={300}
                                                        >
                                                          <Flex
                                                            align="center"
                                                            gap="2"
                                                          >
                                                            <UserAvatar
                                                              username={
                                                                assignee.username
                                                              }
                                                              size={24}
                                                            />
                                                            <Text fontSize="sm">
                                                              {
                                                                assignee.username
                                                              }
                                                            </Text>
                                                          </Flex>
                                                        </Tooltip>
                                                      </MenuItem>
                                                    ),
                                                  )}
                                                </MenuList>
                                              </Menu>
                                            </Td>

                                            {/* Status */}
                                            <Td>
                                              <Menu>
                                                <MenuButton
                                                  as={Button}
                                                  size="xs"
                                                  variant="outline"
                                                  colorScheme="gray"
                                                  rightIcon={
                                                    <ChevronDownIcon />
                                                  }
                                                >
                                                  {selectedStatus}
                                                </MenuButton>
                                                <MenuList>
                                                  {statusList.map((status) => (
                                                    <MenuItem
                                                      key={status.status_name}
                                                      onClick={() => {
                                                        handleEditChange(
                                                          task.issue_id,
                                                          'status',
                                                          status.status_name,
                                                        );
                                                        saveSubtask(
                                                          task.issue_id,
                                                          {
                                                            status:
                                                              status.status_name,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      {status.status_name}
                                                    </MenuItem>
                                                  ))}
                                                </MenuList>
                                              </Menu>
                                            </Td>
                                          </Tr>
                                        );
                                      })}
                                    </Tbody>
                                  </Table>
                                </Box>
                              </Box>
                            </Box>
                          )}
                      </TabPanel>

                      {/* Linked Items */}
                      <TabPanel p={0}>
                        <ListLinkedWorkItems
                          item_id={epicDetails.epic_id}
                          item_type={'epic'}
                          refreshFlag={refreshLinkedItems}
                        />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>

                  {showChildInput && (
                    <HStack
                      mb={4}
                      mt={4}
                      align="center"
                      spacing={2}
                      width="100%"
                    >
                      {/* Label */}
                      <Text fontWeight="semibold" minW="60px">
                        Subtask
                      </Text>

                      {/* Combined Input + Select */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          border: '1px solid #CBD5E0',
                          borderRadius: 6,
                          width: '100%',
                          background: '#fff',
                        }}
                      >
                        <Select
                          value={selectedIssueTypeId}
                          onChange={(value) => {
                            setSelectedIssueTypeId(value);
                            const typeObj = issueTypes.find(
                              (t) => t.id === value,
                            );
                            setSelectedType(typeObj?.label || '');
                          }}
                          style={{ width: 150 }}
                          getPopupContainer={(trigger) => trigger.parentElement}
                        >
                          {issueTypes.map(({ id, label, icon: Icon }) => (
                            <Option key={id} value={id}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                }}
                              >
                                <Icon width={35} />
                                <span>{label}</span>
                              </div>
                            </Option>
                          ))}
                        </Select>

                        <Input
                          placeholder="What needs to be done?"
                          value={childTaskTitle}
                          onChange={(e) => setChildTaskTitle(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && childTaskTitle.trim()) {
                              handleAddSubtask();
                            }
                          }}
                          style={{ flex: 1 }}
                          autoFocus
                        />
                      </div>

                      {/* Add Button */}
                      <Button
                        size="sm"
                        colorScheme="blue"
                        borderRadius="0px"
                        onClick={handleAddSubtask}
                        isDisabled={!childTaskTitle.trim()}
                      >
                        <CornerDownLeft />
                      </Button>

                      {/* Cancel Button */}
                      <Button
                        size="sm"
                        borderRadius="0px"
                        onClick={() => setShowChildInput(false)}
                      >
                        Cancel
                      </Button>
                    </HStack>
                  )}
                   <WebLinkList
                    work_id={epicDetails.epic_id}
                    work_type={'epic'}
                    refreshFlag={refreshLinks}
                  />

               

                  {/* Epic-level only share work item */}
                  <ShareWorkItemModal
                    isOpen={isShareOpen}
                    onClose={() => setIsShareOpen(false)}
                    project_id={projectId}
                    epic_id={epicdata?.epic_id}
                    issue_id={epicDetails?.issue_id}
                    issue_type_id="epic"
                  />

                  <Box>
                    <Epicmodalactivity epicDetails={epicDetails} />
                  </Box>
                </Box>

                <Box
                  width="6px"
                  cursor="ew-resize"
                  bg="gray.200"
                  _hover={{ bg: 'gray.400' }}
                  onMouseDown={onMouseDown}
                />
                <Box
                  flex="none"
                  width={`${rightWidth}px`}
                  p={6}
                  pr={0}
                  right={0}
                  borderLeft="1px solid #e2e8f0"
                  // bg="gray.50"
                  overflowY="auto"
                  style={{
                    height: 'calc(100vh - 210px)', // adjust top/bottom offset as needed
                    // display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', // vertical scrolling
                    // prevent horizontal scroll
                    transition: 'height 0.2s ease', // smooth height change
                  }}
                >
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Menu isDisabled={!isEditable}>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        size="sm"
                        mb={4}
                        p={0}
                        px={0}
                        minW="fit-content"
                        width="fit-content"
                        height="auto"
                        borderRadius="md"
                        bg={bg} // status background
                        color={color} // text color
                        border="1px solid #ccc"
                        _hover={{ bg }}
                        _active={{ bg }}
                      >
                        <Badge
                          bg="transparent"
                          color={color}
                          fontSize="0.8em"
                          p={1}
                        >
                          {currentStatus}
                        </Badge>
                      </MenuButton>

                      {isEditable && (
                        <MenuList>
                          {statusList.map((status) => {
                            const { bg, color } = getStatusColors(
                              status.status_name,
                            );
                            return (
                              <MenuItem
                                key={status.id}
                                onClick={() => {
                                  handleStatusChange(status.status_name);
                                  handleEpicUpdate(status);
                                }}
                              >
                                <Badge
                                  bg={bg}
                                  color={color}
                                  fontSize="0.75em"
                                  p={1}
                                  borderRadius="md"
                                >
                                  {status.status_name}
                                </Badge>
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      )}
                    </Menu>
                  </Tooltip>

                  <Grid
                    templateColumns="120px 1fr"
                    rowGap={5}
                    columnGap={6}
                    alignItems="start"
                  >
                    <Text fontWeight="semibold">Assignee</Text>
                    <Tooltip
                      label={!isEditable ? 'You do not have permission' : ''}
                    >
                      <Popover
                        isOpen={showEmployeePicker}
                        onClose={() => setShowEmployeePicker(false)}
                      >
                        <Box position="relative" width="fit-content">
                          <PopoverTrigger>
                            <HStack
                              spacing={2}
                              onClick={() =>
                                setShowEmployeePicker(!showEmployeePicker)
                              }
                              cursor="pointer"
                            >
                              {selectedEmployee?.username ||
                              epicdata?.assignee_name ? (
                                <>
                                  <UserAvatar
                                    username={
                                      selectedEmployee?.username ||
                                      epicdata?.assignee_name
                                    }
                                    size={24}
                                  />
                                  <Text fontSize="sm">
                                    {selectedEmployee?.username ||
                                      epicdata?.assignee_name}
                                  </Text>
                                </>
                              ) : (
                                <HStack spacing={1} color="gray.500">
                                  <MdOutlinePerson size={20} />
                                  <Text fontSize="sm">Unassigned</Text>
                                </HStack>
                              )}
                            </HStack>
                          </PopoverTrigger>
                        </Box>
                        {isEditable && (
                          <PopoverContent width="auto">
                            <PopoverBody>
                              {assigneeList?.length > 0 ? (
                                <Box maxH="200px" overflowY="auto">
                                  {assigneeList.map((emp) => (
                                    <Box
                                      key={emp.user_id}
                                      onClick={() => {
                                        setSelectedEmployee(emp); // store full object, not just ID
                                        setShowEmployeePicker(false);
                                        handleEpicUpdate(emp);
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      px={2}
                                      py={1}
                                      borderRadius="md"
                                      cursor="pointer"
                                      bg={
                                        selectedEmployee?.user_id ===
                                        emp.user_id
                                          ? '#e6f4ff'
                                          : 'transparent'
                                      }
                                      _hover={{ bg: '#f1f5f9' }}
                                    >
                                      <UserAvatar
                                        username={emp.username}
                                        size={24}
                                        style={{ marginRight: '8px' }}
                                      />
                                      <Text fontSize="sm">{emp.username}</Text>
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                <Text fontSize="sm" color="gray.500">
                                  No employees found
                                </Text>
                              )}
                            </PopoverBody>
                          </PopoverContent>
                        )}
                      </Popover>
                    </Tooltip>

                    <Text fontWeight="semibold">Labels</Text>

                    <Box w="100%">
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        isClearable
                        isMulti
                        placeholder="Select or create label"
                        value={selectedLabel} // ✔ ONLY this
                        options={labellist.map((label) => ({
                          label: label.label_name,
                          value: label.label_id,
                          __isNew__: false,
                        }))}
                        onChange={(newValue) => {
                          const updated = newValue || [];

                          setSelectedLabel(updated);
                          handleAddLabel(updated); // ← Pass updated list
                        }}
                      />
                    </Box>

                    <Text fontWeight="semibold">Due date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                      onBlur={handleEpicUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate(); // ✅ Save on Enter
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Start date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onBlur={handleEpicUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Sprint</Text>
                    <Text>
                      {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        placeholder="Select or create sprint"
                        isClearable
                        value={
                          selectedSprint ||
                          sprintOptions.find(
                            (s) => s.label === epicDetails?.sprint_name,
                          ) ||
                          (epicdata?.sprint_name
                            ? {
                                label: epicdata.sprint_name,
                                value: epicdata.sprint_id,
                              }
                            : null)
                        }
                        options={sprintOptions}
                        onChange={(newValue) => {
                          setSelectedSprint(newValue);
                          handleEpicUpdate();
                        }}
                        formatCreateLabel={(inputValue) =>
                          `Create new sprint: "${inputValue}"`
                        }
                      />
                    </Text>

                    <Text fontWeight="semibold">Story points</Text>
                    <Input
                      size="sm"
                      placeholder="Add story points"
                      w="100%"
                      type="number"
                      value={storyPoints}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Keep only digits (0–9)
                        const onlyInt = value.replace(/[^\d]/g, '');

                        setStoryPoints(onlyInt);
                      }} // <-- update state
                      onBlur={debouncedUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleEpicUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Development</Text>
                    <VStack align="start" spacing={2}></VStack>

                    <Text fontWeight="semibold">Reporter</Text>
                    <HStack align="center" spacing={2}>
                      <Avatar
                        name={epicdata?.created_by_name || 'Unknown'}
                        size="xs"
                      />
                      <Text fontSize="sm" lineHeight="1">
                        {epicdata?.created_by_name || 'Unknown'}
                      </Text>
                    </HStack>
                  </Grid>

                  <div
                    style={{
                      marginTop: 0,
                      padding: '12px 16px',
                      // border: '1px solid #e6e6e6',
                      borderRadius: 8,
                      // background: '#fff',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Created at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {epicdata?.created_at
                          ? dayjs(epicdata?.created_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Updated at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {epicdata?.updated_at
                          ? dayjs(epicdata?.updated_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                  </div>
                </Box>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ListEpicModal;
